var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnplannedTaskLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ellipse 56-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 28,
    id: "img6",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAAXNSR0IB2cksfwAAAGxQTFRF////4+Pmvr7EoKCok5Odh4eR0tLVlpafu7vByMjM6+vs+Pj46ursn5+nnp6n2trd2dnciIiTyMjN1+Tklbm5SYiHI29uDWBggYGM2dnd8/f3kLa1AllYAFhXytzcU46OA1pZJ3Fx+vr67OzuNBvIcgAAANBJREFUeJx9k1kOgzAMRIc1EJZAIOxhae9/x9KWggjU82c9yRrbY+Any3Zcz3Md24Ipn7Eg5FHEw4Ax/4TiJBVHJdIkPqosl0BRqqquK1UWgMyznTUtun7Qm4a+Q9tsNM5bjNOsd83TiDb/dk4kxkWftIyQycdnim7ShqYO6dszE+hnE849BFtnZygGk62uCjALdoDyyrQuEdhwQqg7qBA6cDmqO1iBu/Ai1HewRuTRkGxLGiJHIZdAro9ePHky+thkTOiA0dE8Qv14XkP95x1eknA02elu+6IAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img6",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnplannedTaskLog);
export default __webpack_public_path__ + "static/media/UnplannedTaskLog.eb3cbd8b.svg";
export { ForwardRef as ReactComponent };